/**
 * Skio Bridge
 *
 * Synchronizes the Skio plan picker web component with:
 *   1. The sticky add-to-cart bar (selling_plan_type_ref radios + price)
 *   2. The product media gallery (selling-plan:changed event for image filtering)
 *   3. The form selling_plan hidden input
 *
 * Listens for:
 *   - skio::update-selling-plan  (from Skio component)
 *   - change on selling_plan_type_ref radios (from sticky bar)
 *
 * Dispatches:
 *   - selling-plan:changed (for gallery media filtering)
 */

(function () {
  "use strict";

  // Cache references once DOM is ready
  let stickyRadios = null;
  let priceLabels = null;
  let planPicker = null;

  function getStickyRadios() {
    if (!stickyRadios || stickyRadios.length === 0) {
      stickyRadios = document.querySelectorAll(
        "input[name='selling_plan_type_ref']"
      );
    }
    return stickyRadios;
  }

  function getPriceLabels() {
    priceLabels = document.querySelectorAll(".td-product-form__final-price");
    return priceLabels;
  }

  function getPlanPicker() {
    if (!planPicker) {
      planPicker = document.querySelector("skio-plan-picker");
    }
    return planPicker;
  }

  /**
   * Format cents to a dollar string, stripping trailing .00
   */
  function formatPrice(cents) {
    var dollars = (cents / 100).toFixed(2);
    return "$" + dollars.replace(/\.00$/, "");
  }

  // -------------------------------------------------------------------------
  // 1. Skio → Sticky bar + Gallery + Form
  // -------------------------------------------------------------------------

  document.addEventListener("skio::update-selling-plan", function (event) {
    var detail = event.detail;
    if (!detail) return;

    var sellingPlan = detail.sellingPlan;
    var variant = detail.variant;
    var isSubscription = !!sellingPlan;

    // Update sticky bar radios
    var radios = getStickyRadios();
    radios.forEach(function (radio) {
      if (isSubscription && radio.dataset.type === "sub") {
        radio.checked = true;
      } else if (!isSubscription && radio.dataset.type === "otp") {
        radio.checked = true;
      }
    });

    // Update price labels
    if (variant) {
      var labels = getPriceLabels();
      var price;

      if (isSubscription && variant.selling_plan_allocations) {
        var allocation = variant.selling_plan_allocations.find(function (a) {
          return a.selling_plan_id === sellingPlan.id;
        });
        price = allocation ? allocation.price : variant.price;
      } else {
        price = variant.price;
      }

      var compareAt = variant.compare_at_price;
      var priceHtml;

      if (!isSubscription && compareAt && compareAt > variant.price) {
        priceHtml = "<del>" + formatPrice(compareAt) + "</del> " + formatPrice(variant.price);
      } else {
        priceHtml = formatPrice(price);
      }

      labels.forEach(function (label) {
        label.innerHTML = priceHtml;
      });
    }

    // Dispatch gallery event
    var planType = isSubscription ? "subscription" : "one-time";
    if (typeof window.dispatchSellingPlanChange === "function") {
      window.dispatchSellingPlanChange(planType);
    } else {
      document.dispatchEvent(
        new CustomEvent("selling-plan:changed", {
          bubbles: true,
          detail: { planType: planType },
        })
      );
    }
  });

  // -------------------------------------------------------------------------
  // 2. Sticky bar → Skio
  // -------------------------------------------------------------------------

  document.addEventListener("change", function (event) {
    var target = event.target;
    if (target.name !== "selling_plan_type_ref") return;

    var picker = getPlanPicker();
    if (!picker) return;

    var type = target.dataset.type;

    if (type === "otp") {
      // Switch Skio to one-time
      if (typeof picker.selectSellingPlanGroup === "function") {
        picker.selectSellingPlanGroup(null);
      }
    } else if (type === "sub") {
      // Switch Skio to first available subscription group
      if (
        picker.availableSellingPlanGroups &&
        picker.availableSellingPlanGroups.length > 0
      ) {
        var group = picker.availableSellingPlanGroups[0];
        if (typeof picker.selectSellingPlanGroup === "function") {
          picker.selectSellingPlanGroup(group);
        }
      }
    }
  });

  // -------------------------------------------------------------------------
  // 3. Initial sync — once Skio is defined, read its state and sync outward
  // -------------------------------------------------------------------------

  customElements.whenDefined("skio-plan-picker").then(function () {
    var picker = getPlanPicker();
    if (!picker) return;

    // Wait for the component to finish its first render
    picker.updateComplete.then(function () {
      var isSubscription = !!picker.selectedSellingPlan;

      // Sync sticky bar radios
      var radios = getStickyRadios();
      radios.forEach(function (radio) {
        if (isSubscription && radio.dataset.type === "sub") {
          radio.checked = true;
        } else if (!isSubscription && radio.dataset.type === "otp") {
          radio.checked = true;
        }
      });

      // Sync price
      if (picker.selectedVariant) {
        var labels = getPriceLabels();
        var price;

        if (isSubscription && picker.selectedSellingPlan) {
          var allocation = picker.selectedVariant.selling_plan_allocations.find(
            function (a) {
              return a.selling_plan_id === picker.selectedSellingPlan.id;
            }
          );
          price = allocation ? allocation.price : picker.selectedVariant.price;
        } else {
          price = picker.selectedVariant.price;
        }

        var compareAt = picker.selectedVariant.compare_at_price;
        var priceHtml;

        if (!isSubscription && compareAt && compareAt > picker.selectedVariant.price) {
          priceHtml = "<del>" + formatPrice(compareAt) + "</del> " + formatPrice(picker.selectedVariant.price);
        } else {
          priceHtml = formatPrice(price);
        }

        labels.forEach(function (label) {
          label.innerHTML = priceHtml;
        });
      }

      // Sync gallery
      var planType = isSubscription ? "subscription" : "one-time";
      if (typeof window.dispatchSellingPlanChange === "function") {
        window.dispatchSellingPlanChange(planType);
      }
    });
  });
})();
